import cx from "classnames";
import "./Switch.scss";

type SwitchProps = {
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  name?: string;
  className?: string;
  label?: string;
  disabled?: boolean;
};

const Switch: React.FC<SwitchProps> = ({
  checked = false,
  onChange,
  id,
  name,
  className,
  label,
  disabled = false,
}) => {
  const switchClasses = cx(
    "Switch",
    {
      "Switch--Checked": checked && !disabled,
      "Switch--CheckedDisabled": checked && disabled,
      "Switch--Disabled": disabled,
    },
    className,
  );

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (disabled) return;
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.click();
    }
  };

  return (
    <label className={switchClasses}>
      {label}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        className="Switch__Input"
        id={id}
        name={name}
        disabled={disabled}
      />
      <span className="Switch__Track">
        <span className="Switch__Thumb" />
      </span>
    </label>
  );
};

export { Switch };
